export enum ChatSessionState {
  DEFAULT = 'DEFAULT',
  WAIT_DESTINATION = 'WAIT_DESTINATION',
  WAIT_EXPIRATION_ANSWER = 'WAIT_EXPIRATION_ANSWER',
  WAIT_MENU_ANSWER = 'WAIT_MENU_ANSWER',
  WAIT_RELATIONSHIP = 'WAIT_RELATIONSHIP',
  FINISHED = 'FINISHED'
}

export function getChatSessionStateFrom(state: string): ChatSessionState {
  return ChatSessionState[state as keyof typeof ChatSessionState]
}
